/*  ========================================================================
    # Components - Lightbox
    ========================================================================  */

import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import useLocalization from '../hooks/useLocalization';
import useTranslation from '../hooks/useTranslation';

const Lightbox = ({ children, onClose, show, verticalCenterContent = true }) => {
  // Icons
  const local = useLocalization();
  const iconClose = `${local('svgSprite')}#close`;
  const _ = useTranslation();
  const dialogRef = useRef(null);

  const closeLightBox = e => {
    if (typeof onClose === 'function') onClose(e);
  };

  useEffect(() => {
    if (show) {
      document.body.style = 'overflow: hidden';
      if (dialogRef.current) {
        dialogRef.current.showModal();
      }
    } else {
      document.body.style = null;
      if (dialogRef.current) {
        dialogRef.current.close();
      }
    }
  }, [show, dialogRef]);

  return (
    <>
      <dialog
        className={[
          'c-lightbox',
          show && 'c-lightbox--show',
          verticalCenterContent && 'c-lightbox--vertical-center'
        ].join(' ')}
        ref={dialogRef}
      >
        <div className='c-lightbox__backdrop' onClick={closeLightBox}></div>
        <div className='c-lightbox__close'>
          <button
            type='button'
            className='c-button c-button--white c-button--icon c-button--icon-black'
            onClick={closeLightBox}
            aria-label={_('close')}
          >
            <svg viewBox='0 0 200 200'>
              <use href={iconClose}></use>
            </svg>
          </button>
        </div>
        <div className='c-lightbox__content'>{children}</div>
      </dialog>
    </>
  );
};

Lightbox.propTypes = {
  children: PropTypes.any,
  show: PropTypes.bool,
  onClose: PropTypes.func,
  verticalCenterContent: PropTypes.bool
};

export default Lightbox;
